module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-flex bg-gray pb-fixed-btn"
  }, [_c('backTitleBar'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel"
  }, [_c('div', {
    staticClass: "flex-center product-item click"
  }, [_c('div', {
    staticClass: "alifont icon-weixuanzhong color-999",
    staticStyle: {
      "font-size": ".44rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-center product-item click"
  }, [_c('div', {
    staticClass: "alifont icon-xuanzhong color-main",
    staticStyle: {
      "font-size": ".44rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "flex-center product-item click"
  }, [_c('div', {
    staticClass: "alifont icon-weixuanzhong color-999",
    staticStyle: {
      "font-size": ".44rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("确定换绑")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "con-box"
  }, [_c('div', {
    staticClass: "alifont icon-xpsousuo color-999",
    staticStyle: {
      "font-size": ".4rem"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "flex1 input",
    attrs: {
      "type": "search",
      "placeholder": "搜索商品"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-main fs-28 click"
  }, [_vm._v("搜索")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "fs-28 color-333"
  }, [_vm._v("苹果苹果苹果苹果苹果苹果")]), _vm._v(" "), _c('div', {
    staticClass: "mt-10 fs-28"
  }, [_c('span', {
    staticClass: "color-999"
  }, [_vm._v("价格： ")]), _c('span', {
    staticClass: "color-org"
  }, [_vm._v("¥234")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "fs-28 color-333"
  }, [_vm._v("苹果苹果苹果苹果苹果苹果")]), _vm._v(" "), _c('div', {
    staticClass: "mt-10 fs-28"
  }, [_c('span', {
    staticClass: "color-999"
  }, [_vm._v("价格： ")]), _c('span', {
    staticClass: "color-org"
  }, [_vm._v("¥234")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "fs-28 color-333"
  }, [_vm._v("苹果苹果苹果苹果苹果苹果")]), _vm._v(" "), _c('div', {
    staticClass: "mt-10 fs-28"
  }, [_c('span', {
    staticClass: "color-999"
  }, [_vm._v("价格： ")]), _c('span', {
    staticClass: "color-org"
  }, [_vm._v("¥234")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8218dd94","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/supplyRecord/exchangeProduct.vue
// module id = a8f2
// module chunks = 51